import React from "react";
import { useAppSelector } from "../redux/store";
import { FormFieldProps } from "./FormFieldProps";
import { getFieldComponent } from "./fields/fieldRegistry";

const FormField = ({
  field,
  value,
  onChange,
  index,
  errors = {},
  formData,
  collection,
}: FormFieldProps) => {
  const config = useAppSelector((state) => state.auth.config);

  const FieldComponent = getFieldComponent(field.type);

  return (
    <FieldComponent
      field={field}
      value={value}
      onChange={onChange}
      index={index}
      errors={errors}
      formData={formData}
      collection={collection}
      config={config}
    />
  );
};

export default FormField;
